import { GeoFencingService } from "../serviceshandler/GeoFencingService";
import { InvoiceEditingService } from "../serviceshandler/InvoiceEditingService";
import { ManualPrimaryOrderDayService } from "../serviceshandler/ManualPrimaryOrderDayService";
import { ReplEditingService } from "../serviceshandler/ReplEditingService";
import { UiConfigService } from "../serviceshandler/UiConfigService";

export interface ServiceHandler {
  initialData?: any;
  defaultValues?: any;
  dependsOnRole?: boolean;
  key: string;
  initialConfigMap?: Record<string, any>;
  updatedConfigMap?: Record<string, any>;
  setDefaultValues?: (domainMapping?: any) => Promise<any>;
  pwaRequired?:boolean
  handlePreview?: (
    setPlaygroundConfiguration: any,
    setKeyValue: any,
    keyValue: any,
    subFeature: any,
    setCleanSyncDataLoaderIds: any,
    values: any
  ) => Promise<any>;
  getData?:(savedRole?: any)=> Promise<any>;
  SaveData?: (val: any) => Promise<void>;
  validateBeforeSave?: (values: any) => {
    isValid: boolean;
    errorMessage?: string;
  };
  getPrifillValue?: (key: string) => any;
  updateState(
    config: any,
    newValue: any,
    values: any,
    extendedAttributes?: any
  ): void;
  getDescription(config: string): any;
  requiresStudioSavePopup?: boolean;
}
export const ServiceRegistry: Record<string, new () => ServiceHandler> = {
  uiconfigservice: UiConfigService,
  invoiceeditingservice: InvoiceEditingService,
  repleditingservice:ReplEditingService,
  manualprimaryorderdayservice:ManualPrimaryOrderDayService,
  geofencingservice:GeoFencingService
};
export class ServiceFactory {
  static getService(id: string): ServiceHandler {
    const ServiceClass = ServiceRegistry[id.toLowerCase()];
    if (!ServiceClass) {
      console.log(`This ${id} service is not yet handled`);
      throw new Error();
    }
    return new ServiceClass();
  }
}
